const parallaxImageTextRight = {
  key: 'parallaxImageTextRight',
  componentKey: 'image',
  label: 'Parallax Image Text Right'
};

export default parallaxImageTextRight;
